import { useTranslation } from 'react-i18next'

import Text from '../../../../Text'

import { DocFlowMappingRecipientModalSuggestionsItem } from './DocFlowMappingRecipientModalSuggestionsItem'

import * as styles from './DocFlowMappingRecipientModalSuggestions.module.css'

function DocFlowMappingRecipientModalSuggestions({ disabled, items, onAdd }) {
  const { t } = useTranslation()

  return (
    <div className={styles.DocFlowMappingRecipientModalSuggestions}>
      <Text isSecondary>
        {t('DocFlow.MappingRecipientModalSuggestedMatchesKey', {
          number: items.length,
        })}
      </Text>
      <div className={styles.list}>
        {items.map(item => (
          <DocFlowMappingRecipientModalSuggestionsItem
            disabled={disabled}
            item={item}
            key={item.id}
            onAdd={onAdd}
          />
        ))}
      </div>
    </div>
  )
}

export default DocFlowMappingRecipientModalSuggestions
